<div class="cn-recipient-container">
    <owc-card class="rcp-list" style="box-shadow: none;">
      <div class="rcp-list-title">Recipients List</div>
      <div class="rcp-filter-rows">
        <dl-recipients-filter></dl-recipients-filter>
        <dl-recipients-search></dl-recipients-search>
      </div>
      <div>
         <p *ngIf="contacts >= 0" style="font-size:18px"><span style="font-weight: bold;">Accounts :</span> {{accounts}} &nbsp; <span style="font-weight: bold;">Contacts :</span> {{contacts}}</p>
        <p class="rcp-error-msg" *ngIf="isLimit">Maximum number of contacts is 5000.</p>
        <p class="rcp-error-msg" *ngIf="isWarn">Please check the invalid contacts with
          <span title="Duplicate recipient warning" style="height: 24px;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style="width: 24px; vertical-align: bottom;"><path fill="#D0342C" d="M21.912 20.173L12.813 3.478c-.265-.442-.795-.618-1.237-.353a.69.69 0 0 0-.353.353L2.125 20.173c-.265.442-.089.972.353 1.237.088.088.265.088.442.088h18.197c.53 0 .883-.441.883-.883 0-.177 0-.265-.088-.442zm-9.01-2.208h-1.767v-1.767H12.9v1.767zm0-3.534h-1.767v-5.3H12.9v5.3z"></path></svg>
          </span>.
        </p>
      </div>
    </owc-card>
    <dl-recipients-table (isLimit)="contactLimit($event)" (isWarn)="contactWarn($event)" (dataCount)="contactData($event)"></dl-recipients-table>
  </div>